import { axiosRequest } from '../../axiosRequest';
import { AUDIENCE_TYPES } from 'helpers/notificationDelivery';

const adapterAppRequest = ({ title, message, audience_type, audience }) => {
	const audienceType = audience_type || AUDIENCE_TYPES.VENUES;
	return {
		title,
		message,
		audience_type: audienceType,
		// With ALL the backend ignores the audience: send it empty.
		audience: audienceType === AUDIENCE_TYPES.ALL ? [] : audience || [],
	};
};

// The send is asynchronous: the API responds 202 once the notification and
// its recipients are created, and the messages are sent in the background.
const adapterAppResponse = ({ data, success }) => {
	if (success === false) return { error: true, data };
	return {
		notification_id: data?.notification_id,
		status: data?.status,
		audience_type: data?.audience_type,
		total_recipients: data?.total_recipients ?? 0,
		estimated_segments: data?.estimated_segments,
		selected_venues: Array.isArray(data?.selected_venues)
			? data.selected_venues
			: [],
	};
};

export const createAndSendSms = async (notificationForm) => {
	const data = adapterAppRequest(notificationForm);
	var options = {
		method: 'post',
		url: `dashboard/notifications/send-sms`,
		information: data,
	};

	const response = await axiosRequest(options);

	const notification = adapterAppResponse(response);

	return notification;
};
